"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.default = React.createContext({
    freezeColumnIndex: null,
    freezRowIndex: null,
    minColumnWidth: null,
    maxColumnWidth: null
});
